
















































import authType from '@/store/types/auth';
import { TeipNotifications } from '@/util/teipNotifications';
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'SendPasswordInstructions',
  data() {
    return {
      user: {
        email: '',
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      sendPasswordInstructions: `authModule/${authType.actions.SEND_PASSWORD_INSTRUCTIONS}`,
    }),
    async sendInstructions() {
      this.loading = true;
      const teipNotification = new TeipNotifications();
      try {
        await this.sendPasswordInstructions(this.user);
        teipNotification.success('Se ha enviado un correo con instrucciones para recuperar su contraseña');
        await this.$router.push({
          name: 'Login',
        });
      } catch (err) {
        teipNotification.warning('Correo inválido');
      }
      this.loading = false;
    },
  },
});

